import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import ByzMuiTypography from 'src/components/core-components/mui/inputs/ByzMuiTypography';
import ByzMuiTextField from 'src/components/core-components/mui/inputs/ByzMuiTextField';
import { useTranslate } from 'src/locales/use-locales';

interface ScoreDisplayProps {
  score: number;
}

export const ScoreDisplay: React.FC<ScoreDisplayProps> = ({ score }) => {
  const { t } = useTranslate();

  return (
    <Grid container alignItems="stretch" sx={{ minHeight: '64px' }}>
      <Grid
        xs={12}
        sm={6}
        md={6}
        sx={{
          borderBottom: '1px solid #E0E0E0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          paddingLeft: '30px',
          paddingY: 2,
        }}
      >
        <ByzMuiTypography
          fontWeight={500}
          fontSize="14px"
          sx={{
            textAlign: 'left',
            width: '100%',
          }}
        >
          {t('caprini-risk-assessment.score')}
        </ByzMuiTypography>
      </Grid>
      <Grid
        xs={12}
        sm={6}
        md={6}
        sx={{
          display: 'flex',
          alignItems: 'center',
          paddingY: 1,
          paddingX: 1,
        }}
      >
        <ByzMuiTextField
          sx={{ width: '100%' }}
          color="info"
          label={t('caprini-risk-assessment.score')}
          variant="outlined"
          value={score}
          disabled
        />
      </Grid>
    </Grid>
  );
};



